<template>
  <v-dialog
    class="base-dialog"
    v-model="openComputed"
    width="800"
    scrollable
  >
    <v-card>
      <v-card-title>
        <h3><slot name="title"></slot></h3>
      </v-card-title>
      <v-card-text>
        <v-container>
          <slot></slot>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-end">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';

// Emits ------------------
interface Emits {
  (e: 'update:open', open: boolean): void;
}
const emits = defineEmits<Emits>();

// Props ------------------
interface Props {
  open: boolean,
}
const props = withDefaults(defineProps<Props>(), {
  open: false,
});

// Refs ------------------
const { open } = toRefs(props)
const openComputed = computed({
  get: () => open.value,
  set: (value) => {
    emits('update:open', value)
  }
})
</script>

<style lang="scss">
@use '@/styles/settings.scss';

html {
  overflow-x: auto;
  overflow-y: auto;
  min-width: settings.$display-min-width;
  background-color: rgb(var(--v-theme-background));
}

.base-dialog {

  .v-overlay__content {
    min-width: 1110px;
  }

  .v-card-title {
    padding: 20px 0 0 20px;
  }

  .v-container{
    padding-top: 12px;
  }

  .v-card-actions {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(25px);
  }
}
</style>
